module.exports = __webpack_public_path__ + "img/IRON_AMENITY.f9f25c1b.svg";